/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerDTO,
  GetProductsParams,
  ProductDTO,
  SearchCustomers1Params
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get a specific customer by branch and customer number
 * @summary Get customer
 */
export const getCustomer = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerDTO>(
      {url: `/api/frontend/customers/${branch}/${custNo}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCustomerQueryKey = (branch?: string,
    custNo?: string,) => {
    return [`/api/frontend/customers/${branch}/${custNo}`] as const;
    }

    
export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = unknown


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get products for a specific customer
 * @summary Get customer products
 */
export const getProducts = (
    branch: string,
    custNo: string,
    params: GetProductsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/${branch}/${custNo}/products`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetProductsQueryKey = (branch?: string,
    custNo?: string,
    params?: GetProductsParams,) => {
    return [`/api/frontend/customers/${branch}/${custNo}/products`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = unknown


export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer products
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductsQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get loan products for a specific customer
 * @summary Get loan products
 */
export const getLoansProducts = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/${branch}/${custNo}/loan-products`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLoansProductsQueryKey = (branch?: string,
    custNo?: string,) => {
    return [`/api/frontend/customers/${branch}/${custNo}/loan-products`] as const;
    }

    
export const getGetLoansProductsQueryOptions = <TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoansProductsQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansProducts>>> = ({ signal }) => getLoansProducts(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoansProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoansProducts>>>
export type GetLoansProductsQueryError = unknown


export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan products
 */

export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoansProductsQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Search for customers by query
 * @summary Search customers
 */
export const searchCustomers1 = (
    branch: string,
    params: SearchCustomers1Params,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerDTO[]>(
      {url: `/api/frontend/customers/search/${branch}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchCustomers1QueryKey = (branch?: string,
    params?: SearchCustomers1Params,) => {
    return [`/api/frontend/customers/search/${branch}`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchCustomers1QueryOptions = <TData = Awaited<ReturnType<typeof searchCustomers1>>, TError = unknown>(branch: string,
    params: SearchCustomers1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomers1QueryKey(branch,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomers1>>> = ({ signal }) => searchCustomers1(branch,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchCustomers1QueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomers1>>>
export type SearchCustomers1QueryError = unknown


export function useSearchCustomers1<TData = Awaited<ReturnType<typeof searchCustomers1>>, TError = unknown>(
 branch: string,
    params: SearchCustomers1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers1>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomers1<TData = Awaited<ReturnType<typeof searchCustomers1>>, TError = unknown>(
 branch: string,
    params: SearchCustomers1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers1>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomers1<TData = Awaited<ReturnType<typeof searchCustomers1>>, TError = unknown>(
 branch: string,
    params: SearchCustomers1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search customers
 */

export function useSearchCustomers1<TData = Awaited<ReturnType<typeof searchCustomers1>>, TError = unknown>(
 branch: string,
    params: SearchCustomers1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchCustomers1QueryOptions(branch,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a list of all products
 * @summary Get all products
 */
export const getAllProducts2 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/products`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllProducts2QueryKey = () => {
    return [`/api/frontend/customers/products`] as const;
    }

    
export const getGetAllProducts2QueryOptions = <TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProducts2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProducts2>>> = ({ signal }) => getAllProducts2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProducts2QueryResult = NonNullable<Awaited<ReturnType<typeof getAllProducts2>>>
export type GetAllProducts2QueryError = unknown


export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all products
 */

export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProducts2QueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get products filtered by type
 * @summary Get products by type
 */
export const getProductByType = (
    product: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/products/by-type/${product}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProductByTypeQueryKey = (product?: string,) => {
    return [`/api/frontend/customers/products/by-type/${product}`] as const;
    }

    
export const getGetProductByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductByTypeQueryKey(product);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByType>>> = ({ signal }) => getProductByType(product, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(product), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductByType>>>
export type GetProductByTypeQueryError = unknown


export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get products by type
 */

export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductByTypeQueryOptions(product,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



